import { CustomerProducts } from 'store/slices/customerProductsSlice';
import { store } from 'store/store';
// Kerne producter:
// Indboforsikring
// Husforsikring
// Fritidshusforsikring
// Husforsikring - Nedlagt landbrug
// Bilforsikring
// Ulykkesforsikring, Børneulykkesforsikring, Sundhedsforsikring eller Udvidet strakserstatning.

// Kerne rabat produkter
// Motorcykelforsikring
// Kolonihavehusforsikring
// Påhængsvognsforsikring
// Campingvognsforsikring
// Knallertforsikring
// Hundeforsikring
// Rejseforsikring
// Bilforsikring Køretøj Special
// Børneulykkesforsikring til 0 kr. til dit barn indtil det fylder 3 år, når du opfylder kriterierne for at være Kernekunde.

const coreKeyProducts = [
	CustomerProducts.HOME,
	CustomerProducts.HOUSE,
	CustomerProducts.HOLIDAY_HOUSE,
	CustomerProducts.CAR,
	CustomerProducts.ACCIDENT,
];

export interface CustomerConceptDiscount {
	value: number;
	products: string[];
	valueFormatted: string;
}

export const getCustomerConceptDiscount = (): CustomerConceptDiscount => {
	const uniqueProducts = store.getState().customerProducts.uniqueProducts;
	const products = coreKeyProducts.filter((product) => uniqueProducts?.includes(product));
	return getDiscount(products);
};

const getDiscount = (products?: string[]): CustomerConceptDiscount => {
	const length = products?.length ?? 0;
	switch (length) {
		case 0:
			return { value: 0, products: [], valueFormatted: '0 %' };
		case 1:
			return { value: 0.05, products, valueFormatted: '5 %' };
		case 2:
			return { value: 0.1, products, valueFormatted: '10 %' };
		default:
			return { value: 0.15, products, valueFormatted: '15 %' };
	}
};

// additional products which do not increase the discount, but are still listed as part of the discount concept
//  travel,
//  dog,
//  trailer,
//  caravan,
//  moped,

// Missing:
// Kolonihavehusforsikring
// Bilforsikring Køretøj Special
// Børneulykkesforsikring til 0 kr. til dit barn indtil det fylder 3 år, når du opfylder kriterierne for at være Kernekunde.
